import React from 'react';

import SendbirdProvider from '@sendbird/uikit-react/SendbirdProvider';
import ko from 'date-fns/locale/ko';

import { useSendbirdTokenList } from '../apis/acloset/query/acloset-query';

/**
 * Acloset 채팅 Provider.
 */
export const AclosetChatProvider = ({ children }: { children: React.ReactNode }) => {
  const { data: tokenData, isLoading } = useSendbirdTokenList();

  if (isLoading) {
    return null;
  }

  return (
    <SendbirdProvider
      appId={import.meta.env.VITE_PUBLIC_SENDBIRD_APP_ID}
      userId={tokenData && tokenData.userID ? `${tokenData.userID}` : ''}
      accessToken={tokenData?.accessToken}
      allowProfileEdit={false}
      stringSet={stringSet}
      dateLocale={ko}
      // config={{
      //   logLevel: 'error',
      // }}
      isTypingIndicatorEnabledOnChannelList
    >
      {children}
    </SendbirdProvider>
  );
};

const stringSet: Record<string, string> = {
  CHANNEL__MESSAGE_LIST__NOTIFICATION__NEW_MESSAGE: '개의 새 메시지',

  TRYING_TO_CONNECT: '연결 시도 중...',
  TYPING_INDICATOR__IS_TYPING: '님이 입력 중...',

  MESSAGE_MENU__COPY: '복사',

  NO_TITLE: '제목 없음',
  NO_NAME: '(이름 없음)',

  MESSAGE_INPUT__PLACE_HOLDER: '메시지 입력하기',
  MESSAGE_STATUS__YESTERDAY: '어제',
};
